import React from "react";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import PrimaryTableCell from "app/Components/Tables/PrimaryTableCell";

const MUICashTableHeader = () => (
  <TableHead>
    <TableRow>
      <PrimaryTableCell align="center" key="gameName">
        Name
      </PrimaryTableCell>
      <PrimaryTableCell align="center" key="Game">
        Game
      </PrimaryTableCell>
      <PrimaryTableCell align="center" key="Limit">
        Limit
      </PrimaryTableCell>
      <PrimaryTableCell align="center" key="Status">
        Status
      </PrimaryTableCell>
      <PrimaryTableCell align="center" key="Distance">
        Distance
      </PrimaryTableCell>
      <PrimaryTableCell align="center" key="Waitlist">
        Waitlist
      </PrimaryTableCell>
      <PrimaryTableCell align="center" key="Options">
        Options
      </PrimaryTableCell>
    </TableRow>
  </TableHead>
);

export default MUICashTableHeader;
